/**
 * Lightweight ID obfuscation for URL params.
 *
 * Encodes a numeric DB id into a base64 token so raw IDs like "106"
 * are never visible in the browser URL bar.
 *
 * This is NOT encryption — it is obfuscation to prevent casual ID
 * enumeration and to avoid leaking DB primary keys to end users.
 *
 * Example:
 *   encodeId(106)  → "aWRyXzEwNg"
 *   decodeId("aWRyXzEwNg") → 106
 */

const PREFIX = 'idr_'

export function encodeId(id: number): string {
  return btoa(PREFIX + id).replace(/=+$/, '')
}

export function decodeId(token: string): number | null {
  try {
    // Restore stripped padding
    const padded = token + '==='.slice(0, (4 - (token.length % 4)) % 4)
    const decoded = atob(padded)
    if (!decoded.startsWith(PREFIX)) return null
    const num = parseInt(decoded.slice(PREFIX.length), 10)
    return isNaN(num) ? null : num
  } catch {
    return null
  }
}
